module.exports = __webpack_public_path__ + "static/img/1.271ceaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/1.jpg
// module id = OqRD
// module chunks = 1